import { Type } from "@angular/core";
import { ToolBarComponent } from "../tool-bar/tool-bar.component";
import { DataTableOptionsComponent } from "../tool-bar/data-table-options/data-table-options.component";

export interface TableSettings {
    toolbars: { component: Type<any>, data: any }[]
}

export function defaultTableSettings(): TableSettings {
    return {
        toolbars: [
            {
                component: ToolBarComponent,
                data: [DataTableOptionsComponent]
            }
        ]
    };
} 